function Crest({ className }) {
  return (
    <svg
      aria-hidden="true"
      className={className ? `crest ${className}` : "crest"}
      viewBox="0 0 64 64"
    >
      <circle cx="32" cy="32" fill="none" r="30" strokeWidth="1" />
      <circle cx="32" cy="32" fill="none" r="25.5" strokeWidth="0.75" />
      <path d="M32 8.5 L32 13" strokeWidth="1" />
      <path d="M32 51 L32 55.5" strokeWidth="1" />
      <path d="M8.5 32 L13 32" strokeWidth="1" />
      <path d="M51 32 L55.5 32" strokeWidth="1" />
      <text
        dy="0.35em"
        fontFamily="'Geist', sans-serif"
        fontSize="20"
        fontWeight="800"
        textAnchor="middle"
        x="32"
        y="33.5"
      >
        RD
      </text>
    </svg>
  );
}

export default Crest;
